import com from 'js/common.js';
import 'scss/pages/index';
import channel from 'common/channel';
//import carousel from 'common/carousel';
import '../static/css/swiper.css';
import Swiper from '../static/js/swiper.js';
var app = new Vue({
    el: '#app',
    data:{
     isShow:false,
     swiper:null,
     params: {
			page: 1,
			pageSize: 5,
			orderByField: 'increasePercent',
			filterFields: {},
			orderType: 1
		},
	 curentIndex:0,
	 activeIndex:0,
//   teacherList:[],
     bannerList:[],
     titles: ['全部', '沪深A股', '上证A股', '深证A股', '中小板', '创业板', 'B股'],
	tableColumn: [{
			prop: 'stockName',
			lable: '名称',
			width: '80'
		}, {
			prop: 'newstPrice',
			lable: '最新价',
			width: '80'
		}, {
			prop: 'increasePercent',
			lable: '涨跌幅',
			width: '80'
		}, {
			prop: 'increasePrice',
			lable: '涨跌额',
			width: '68'
		},{
			prop: 'operate',
			lable: '自选',
			width: '50'
		}],
		tableData: [],
		channelData:[{
			     	imgSrc:'',
			     	imgLink:''
			     },{
			     	imgSrc:'',
			     	imgLink:''
			     },{
			     	imgSrc:'',
			     	imgLink:''
			     },{
			     	imgSrc:'',
			     	imgLink:''
		}],
     	comHideFun:com.methods.hideList
    },
    components:{channel},
   	mounted: function() {
		var _this = this;
		_this.getData();
		_this.timer = setInterval(function() {
			_this.tabswitch(_this.activeIndex); //修改数据date
		}, 180000);
		$('.swiper-button-prev').on('click',function(){
			_this.swiper.slidePrev();
		});
		$('.swiper-button-next').on('click',function(){
			_this.swiper.slideNext();
		});
	},
	computed:{},
	beforeDestroy: function() {
		if(this.timer) {
			clearInterval(this.timer); //在Vue实例销毁前，清除我们的定时器
		}
	},
	updated:function(){
      this.showBtn();
    },
    methods:{
    	getData: function() {
    		var $this=this;
    		var opts={
		    	 	isLoading:true,
		    	 	loadingDom:'div.block-box',
		    	 	success:function(result){
		    	 		var html='';
		    	 		for (var item in result.data) {
		    	 			result.data[item]=JSON.parse(result.data[item]);
		    	 		}
		    	 		for (var i=0;i<result.data['stock-1-6'].data.length;i++) {
		    	 			if (result.data['stock-1-6'].data[i].link) {
		    	 				html+='<div class="swiper-slide famous-item">'+
							    	'<a href="'+result.data['stock-1-6'].data[i].link+'"><img src="'+result.data['stock-1-6'].data[i].picsrc+'"/></a>'+
			        				'<p class="famous-name">'+result.data['stock-1-6'].data[i].prop1+'</p>'+
			        				'<p class="famous-des">'+result.data['stock-1-6'].data[i].prop2+'</p>'+
			        				'<a href="'+result.data['stock-1-6'].data[i].link+'" class="more">查看详情</a>'+
							    '</div>';
		    	 			}
		    	 		}
		    	 		for (var j=0;j<result.data['stock-1-1'].data.length;j++) {
		    	 			if (result.data['stock-1-1'].data[j].picsrc) {
		    	 				$this.bannerList.push(result.data['stock-1-1'].data[j]);
		    	 			}
		    	 		}
		    	 		$this.channelData.splice(0,1,{imgSrc:result.data['stock-1-2'].data[0].picsrc,imgLink:result.data['stock-1-2'].data[0].link});
		    	 		$this.channelData.splice(1,1,{imgSrc:result.data['stock-1-3'].data[0].picsrc,imgLink:result.data['stock-1-3'].data[0].link});
		    	 		$this.channelData.splice(2,1,{imgSrc:result.data['stock-1-4'].data[0].picsrc,imgLink:result.data['stock-1-4'].data[0].link});
		    	 		$this.channelData.splice(3,1,{imgSrc:result.data['stock-1-5'].data[0].picsrc,imgLink:result.data['stock-1-5'].data[0].link});
		    	 		$(".swiper-wrapper").html(html);
		    	 		$this.swiper= new Swiper('.swiper-container',{
		    	 			prevButton:'.swiper-button-prev',
                            nextButton:'.swiper-button-next',
							loop: true,
							slidesPerView: 'auto',
							loopedSlides: result.data['stock-1-6'].data.length,
							speed:150
						});
		    	 	}
    	 		},
    	 		optsMarket = {
				isLoading: true,
				loadingDom: 'div.tables',
				success: function(result) {
					result.data.forEach(function(value, index) {
						if(typeof value == 'object') {
							for(var item in value) {
								if(value[item] == '') {
									value[item] = '--';
								}
								if(item != 'stockName'&&item != 'stockCode') {
									if(value[item] && (!isNaN(Number(value[item])))) {
										value[item] = Number(value[item]);
									}
								}
							}
						}
					});

					$this.tableData = result.data;
				}
			};
            $this.getAjaxCom('crm/getStockHomeCrm','get','',opts);
            $this.getAjax('stock/codes.json', $this.params, optsMarket);
    	},
    	showBtn:function(){
	    	var _this=this;
	    	if(_this.num>4){
	    	  	_this.isShow=false;
	    	 }else{
	    	 	_this.isShow=true;
	    	 }
	     },
    	compareDecimal: function(value1, value2) {
			var val1 = Number(value1);
			var val2 = Number(value2);
			val1 = !isNaN(Number(val1)) ? val1.toFixed(2) : 0;
			val2 = !isNaN(Number(val2)) ? val2.toFixed(2) : 0;
			if(parseFloat(val1) - parseFloat(val2) > 0) {
				return 1;
			} else if(parseFloat(val1) - parseFloat(val2) < 0) {
				return -1;
			} else {
				return 0;
			}
		},
		tabswitch: function(index, event) {
			var _this = this;
			_this.tableData=[];
			_this.curentIndex = index;
			_this.activeIndex=index;
			var opts = {
				isLoading: true,
				loadingDom: 'div.tables',
				success: function(result) {
					result.data.forEach(function(value, index) {
						if(typeof value == 'object') {
							for(var item in value) {
								if(item != 'stockName') {
									if(value[item] == '') {
										value[item] = '--';
									}
									if(item != 'stockName'&& item != 'stockCode') {
										if(value[item] && (!isNaN(Number(value[item])))) {
											value[item] = Number(value[item]);
										}
									}
								}
							}
						}
					});

					_this.tableData = result.data;
				}
			};
			switch(index) {
				case 0:
					_this.params.filterFields = {};
					break;
				case 1:
					_this.params.filterFields = JSON.stringify({ //沪深A股
						type: "A"
					});
					break;
				case 2:
					_this.params.filterFields = JSON.stringify({//上证A股
						market: "SH",
						type: "A"
					});
					break;
				case 3:
					_this.params.filterFields = JSON.stringify({//深证A股
						market: "SZ",
						type: "A"
					});
					break;
				case 4:
					_this.params.filterFields = JSON.stringify({//中小板
						type: "2A"
					});
					break;
				case 5:
					_this.params.filterFields = JSON.stringify({//创业板
						type: "3A"
					});
					break;
				case 6:
					_this.params.filterFields = JSON.stringify({//B股
						type: "B"
					});
					break;
				default:
					break;
			}
			_this.getAjax('stock/codes.json', _this.params, opts);
		},
		setCookies: function(stockCode) {
			var cookiesArr = [];
			var len = 0;
			if(this.cookies().read('stockCode')) {
				cookiesArr = JSON.parse(this.cookies().read('stockCode'));
				len = cookiesArr.length;

				for(var i = 0; i < len; i++) {
					if(stockCode == cookiesArr[i].codeKey) {
						break;
					} else {
						if(i == len - 1) {
							cookiesArr.push({
								tab: 0,
								codeKey: stockCode
							});
						} else {
							continue;
						}
					}

				}

			} else {
				cookiesArr.push({
					tab: 0,
					codeKey: stockCode
				});
			}
			cookiesArr = JSON.stringify(cookiesArr);
			this.cookies().write('stockCode', cookiesArr, 30);
			window.open('/selectOptionStock/selectOptionStock.html');
		}
    }
});



//////////////////
// WEBPACK FOOTER
// ./views/index.js
// module id = Cs+i
// module chunks = 9